import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb, Button } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import ArticleForm from './components/ArticleForm';

import withGraphqlData from '../shared/components/withGraphqlData';
import { ArticleDetailsQuery, UpdateArticleMutation, DeleteArticleMutation } from './queries';
import { parseFormErrors } from '../shared/utils/form_errors';

class EditArticle extends Component {
  constructor(props) {
    super(props);

    this.state = { deleting: false, deleteError: null };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleSubmit(data) {
    this.setState({ deleteError: null });
    const { client, objectId, push } = this.props;
    return client.mutate({
      mutation: UpdateArticleMutation, variables: { id: objectId, update: data }
    })
      .then(() => push('/news'))
      .catch(parseFormErrors);
  }

  handleDelete() {
    this.setState({ deleting: true, deleteError: null });
    const { client, objectId, push } = this.props;
    return client.mutate({ mutation: DeleteArticleMutation, variables: { id: objectId } })
      .then(() => push('/news'))
      .catch(error => this.setState({
        deleting: false, deleteError: error.message,
      }));
  }

  render() {
    const { role } = this.props.user;
    const { Article, ModelTags, SneakerModels } = this.props.data;
    const { deleting, deleteError } = this.state;

    const deleteButton = (
      <Button ghost disabled={deleting} loading={deleting} onClick={this.handleDelete} type="danger">
        <AntIcon type="delete" />Delete
      </Button>
    );

    const formArticle = {
      ...Article,
      tag: Article.tag && Article.tag._id,
      sneakerModel: Article.sneakerModel && Article.sneakerModel._id
    };

    return (
      <div id="edit-article">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/news">News</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Article</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ArticleForm
            initialValues={formArticle}
            onSubmit={this.handleSubmit}
            deleteButton={role === 'admin' && deleteButton}
            deleteError={deleteError}
            tags={ModelTags}
            sneakerModels={SneakerModels}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withProps(({ match }) => ({
    objectId: match.params.id,
  })),
  withGraphqlData(
    ArticleDetailsQuery,
    (props) => ({ id: props.objectId }),
    'network-only',
  ),
  connect(({ auth: user }) => ({ user }), { push }),
  withApollo,
)(EditArticle);
